var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconBoard(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 37",
    style: {
      fill: "none"
    },
    d: "M0 0h20v20H0z"
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "\\uC0AC\\uAC01\\uD615 115",
    width: 12,
    height: 16,
    rx: 2,
    transform: "translate(4 2)",
    style: {
      fill: "current"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 404"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC120 8",
    transform: "translate(7 6.5)",
    style: {
      stroke: "#232c51",
      strokeLinecap: "round",
      strokeWidth: "1.5px",
      fill: "none"
    },
    d: "M0 0h6"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC120 9",
    transform: "translate(7 10)",
    style: {
      stroke: "#232c51",
      strokeLinecap: "round",
      strokeWidth: "1.5px",
      fill: "none"
    },
    d: "M0 0h6"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC120 10",
    transform: "translate(7 13.5)",
    style: {
      stroke: "#232c51",
      strokeLinecap: "round",
      strokeWidth: "1.5px",
      fill: "none"
    },
    d: "M0 0h6"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBoard);
export default __webpack_public_path__ + "static/media/icon_board.915d84e7b4636aaa358e2aa12d02c8b4.svg";
export { ForwardRef as ReactComponent };